<template>
  <div class="company-wall-details-characteristics-skeleton">
    <IconInfoCardSkeleton description-width="120px" title-width="80px" />
    <IconInfoCardSkeleton description-width="130px" title-width="70px" />
    <IconInfoCardSkeleton description-width="100px" title-width="60px" />
    <IconInfoCardSkeleton description-width="135px" title-width="100px" />
  </div>
</template>

<script setup lang="ts">
import IconInfoCardSkeleton from "~/features/company-wall/components/company-wall-details/content/IconInfoCardSkeleton.vue";
</script>

<style scoped lang="postcss">
.company-wall-details-characteristics-skeleton {
  @apply grid grid-cols-1 gap-6 md:grid-cols-2;
}
</style>
